import { Option } from "@/components/AsyncSelect/AsyncSelect";
import ProjectTypeSelect from "@/components/ProjectTypeSelect";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import { FilterType } from "@/lib/filters";
import { noop } from "@/lib/noop";
import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

const FILTER_COLUMN_ID = "project_type_id";

const ProjectTypeFilter = () => {
  const { options } = useDataTableSettings();
  const value = options.getFilterValue(FILTER_COLUMN_ID)?.value;
  const [selectedItem, setSelectedItem] = useState<Option | undefined>();

  useEffect(() => {
    if (value === undefined) {
      setSelectedItem(undefined);
    }
  }, [value]);

  const handleChange = useCallback(
    (nextValue: string | undefined, option?: Option) => {
      if (!nextValue || nextValue === value) {
        setSelectedItem(undefined);
        options.resetFilterById(FILTER_COLUMN_ID);
        return;
      }
      setSelectedItem(option);
      options.setFilterValue(FILTER_COLUMN_ID, {
        value: nextValue,
        filter: FilterType.EqualsString,
      });
    },
    [options, value],
  );

  return (
    <ProjectTypeSelect
      value={value}
      onChange={handleChange}
      onBlur={noop}
      name={FILTER_COLUMN_ID}
      className={cn({
        "bg-blue-100 border-blue-300 text-blue-700": value !== undefined,
      })}
      defaultItem={selectedItem}
      allowClearSelection
    />
  );
};

export default ProjectTypeFilter;
